export default function CampInfo() {
  window.scrollTo(0, 0);

    const removeBottomMargin = {
    marginBottom: "0",
  };

  return (
    <section className='page-text-white bg-green-blue-gradient bg-rotate page-container'>


        <div className='text-left box-width page-box'>

      <h1 className='text-h1'>Camp Information</h1>

      <h2>Relevant resources</h2>
      <ul style={{marginTop: "1rem"}}>
        <li>
          <a
            href='/docs/booklet_camp_2025.pdf'
            rel="noopener noreferrer"
          >
            Booklet (PDF)
          </a>
        </li>
        <li>
          <a
            href='/docs/planning.pdf'
            rel="noopener noreferrer"
          >
            Planning (PDF)
          </a>
        </li>
      </ul>

        <h2>Bus Arrival (To Camp)</h2>
        <p>
          The camp bus departs from{" "}
          <strong>Shetlandsgade 6, 2300 Copenhagen</strong> on{" "}
          <strong>Wednesday, May 28</strong> at <strong>19:00</strong>. The ride
          is free and goes directly to the camp site.
          <br />
          <br />
          <strong>Please arrive at least 1 hour early</strong> before the departure time.
        </p>
        <h2>Bus Departure (From Camp)</h2>
        <p>
          On <strong>Sunday, June 1</strong>, the bus will leave the camp at
          around <strong>16:00</strong>. It will return to{" "}
          <strong>Shetlandsgade 6, 2300 Copenhagen</strong> and also pass by{" "}
          <strong>Copenhagen Central Station</strong> on the way.
        </p>
        <h2>Camp Address</h2>
        <p>
          The camp will be held at: <br />
          <strong>Overdrevsvej 10, 4340 Tølløse, Denmark</strong>.
          <br />
          Link to the campsite:{" "}
          <a
            href='https://birkedal-lejren.dk/'
            target='_blank'
            rel='noopener noreferrer'
            className='underline text-white'
          >
            Birkedal lejren
          </a>
          .
          <br />
          <br />
          The nearest train station is <strong>Tølløse Station</strong>. If
          you’re not able to catch the bus at 19:00 or plan to arrive another
          day, please let us know in advance. We can arrange a pickup from the
          station — the drive takes about 20 minutes one way.
          <br />
          <br />
          For train directions, visit:{" "}
          <a
            href='https://www.rejseplanen.dk/webapp/#!P|TP!histId|0!histKey|H222053'
            target='_blank'
            rel='noopener noreferrer'
            className='underline text-white'
          >
            Rejseplanen.dk
          </a>
        </p>
        <h2>Reminder</h2>
        <p>
          For those who have reserved a bed at the camp, please remember to
          bring:
        </p>
        <ul className='list-disc list-inside pl-4'>
          <li>Pillow</li>
          <li>Pillow cover</li>
          <li>Duvet</li>
          <li>Duvet cover</li>
          <li>Mattress cover</li>
        </ul>
        <p>
          If you paid the <strong>stay-in price</strong>, please remember to
          bring your own <strong>mattress</strong> (you will be sleeping in the
          basement) or bring your own <strong>tent</strong>.
        </p>
      </div>
    </section>
  );
}
